
import Vue from "vue";
import loginService from "../../services/loginService";
import msDataProvider from "../../services/msDataProvider";
import XCardBasedForm from "../../components/XCardBasedForm.vue";
import uiService from "../../services/uiService";
import errorService from "../../services/errorService";
import {addAction} from "@/services/firebase/writeData";
import LocalStorage from "@/services/localStorage";

export default Vue.extend({
  components: {
    XCardBasedForm,
  },
  data() {
    return {
      raw_data: [],
      type_keycode: new Map(),
      showOtpInput: false,
      passwordWithOtp: false,
      openIdConnectMethods: [],
      showPwd: false,
      errorService,
      isClickDoublePassword: false,
      backendServerName: "",
      defaultBackendServerName: "",
      required: (value, label) => !!value || (label || '') + ' ' + this.$t("USERNAME_PASSWORD.REQUIRED"),
      data: {},
      ready: false,
      previousBackendServerName: "",
      successBackendServerName: "",
      replacedBackendServerName: "",
      loginType: ''
    };
  },
  methods: {
    clickDoublePassword() {
      this.isClickDoublePassword = true
    },
    keyHandler(event) {
      if (event.code === undefined) {
        return
      }
      if (event.type === "keydown" &&
          this.type_keycode.has(event.code) &&
          this.type_keycode.get(event.code) === "keydown") {
        return
      }
      if (event.type === "keyup") {
        this.type_keycode.clear()
      } else if (event.type === "keydown") {
        this.type_keycode.set(event.code, event.type)
      }

      if (event.type === "keyup" && this.data && this.data.password !== undefined && this.data.password.length === 0) {
        this.raw_data = []
        this.type_keycode.clear()
        return;
      }
      if (this.isClickDoublePassword && event.type === "keydown") {
        this.raw_data = []
        this.type_keycode.clear()
        this.isClickDoublePassword = false
      }
      this.raw_data.push({
        "keycode": event.code,
        "time": Math.round(event.timeStamp),
        "type": (event.type === "keydown") ? "down" : "up",
      })
    },
    clickPassword(event) {
      this.isClickDoublePassword = false
      sessionStorage.setItem("pointer_type", event.pointerType);
    },
    async submit(callback) {
      let dataBiometric: any

      if (this.raw_data.length > 0) {
        const feature_to_send = loginService.extract(this.raw_data)
        if (this.data.password.length >= 8 && feature_to_send.length <= this.data.password.length * 2) {
          const metaData = await loginService.getMetaData()
          dataBiometric = {
            steps: feature_to_send,
            meta_data: metaData,
          }
          sessionStorage.setItem("biometricData", JSON.stringify(dataBiometric));
        }
      }
      sessionStorage.setItem("serverName", this.backendServerName.trim());

      const valid = await this.checkBackendServerName();

      if (valid) {
        try {
          this.$emit("error", "");
          let dataBiometricRequest = ""
          if (dataBiometric) {
            dataBiometricRequest = JSON.stringify(dataBiometric)
          }
          const response = await msDataProvider.executeCommand("authenLogin", {
            type: "UsernamePassword",
            login_name: this.data.loginName.trim(),
            password: this.data.password,
            user_agent: navigator.userAgent,
            otp: this.data.otp,
            biometric_data: dataBiometricRequest,
            provider_name: this.loginType
          });
          if (response.error_info.error_code) {
            callback(response.error_info.message, false);
            await addAction(
                "click_to_login",
                response.error_info,
                {
                  notLogged: true,
                },
                this.data.loginName.trim()
            );
            await addAction(
                "click_to_login",
                response.error_info,
                {
                  notLogged: true,
                },
                "login_with_username_password_or_radius"
            );
          } else {
            this.storeLoginName();
            sessionStorage.setItem("email", this.data.loginName.trim());
            this.$router.push("prepare").catch((e) => e);
            callback();
            await addAction(
                "click_to_login",
                response.error_info,
                {
                  notLogged: false,
                },
                "login_with_username_password_or_radius"
            );
          }
        } catch (e: any) {
          const {showNotiSystem} = this.errorService.normalize(e);
          callback(e, showNotiSystem);
          await addAction(
              "click_to_login",
              e && e.message,
              {
                notLogged: true,
              },
              this.data.loginName.trim()
          );
        }
      } else {
        callback();
      }
    },
    storeLoginName() {
      const loginName = LocalStorage.getItem('login_name');
      if (typeof loginName === 'object' && !!loginName) {
        if (loginName[this.backendServerName]) {
          LocalStorage.setItem('login_name', {
            ...loginName,
            [this.backendServerName]: {
              ...loginName[this.backendServerName],
              [this.loginType]: this.data.loginName.trim()
            }
          });
        } else {
          LocalStorage.setItem('login_name', {
            ...loginName,
            [this.backendServerName]: {
              [this.loginType]: this.data.loginName.trim()
            }
          });
        }
      } else {
        LocalStorage.setItem('login_name', {
          [this.backendServerName]: {
            [this.loginType]: this.data.loginName.trim()
          }
        })
      }
    },
    async openIdHandler(openIdConnect) {
      const currentBackendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
      if (
          this.successBackendServerName &&
          currentBackendServerName !== this.successBackendServerName
      ) {
        try {
          await msDataProvider.executeCommand(
              "backendServerNameSetCurrentValue",
              this.successBackendServerName
          );
        } catch (e) {
          return;
        }
      }

      const authenToken = sessionStorage.getItem("authenToken") || "";
      let authorizedToken = "";
      if (authenToken) {
        authorizedToken = `authorized_token=${authenToken}`;
      }
      const mainPath = location.origin;
      const oauthPathUrl = mainPath + "/ui/oauth-redirect";
      const openIdConnectUrlCallback =
          openIdConnect.redirect_url +
          "?redirect=" +
          mainPath +
          "/ui/oauth-success";
      const urlOauthRedirect =
          oauthPathUrl +
          "?" +
          authorizedToken +
          "&keep_default_url=true&oauth_url=" +
          encodeURIComponent(openIdConnectUrlCallback);
      const response = await msDataProvider.executeCommand("extOpenUrl", {
        url: urlOauthRedirect,
      });
      const error: any = {}
      if (response) {
        error.message = "Login successful"
      } else {
        error.message = "Login failed"
      }
      await addAction(
          "click_to_login_open_id_connect",
          error,
          {
            notLogged: false,
          },
          "login_with_open_id_connect",
          urlOauthRedirect,
      );
    },
    goTo(path: string) {
      this.$router.push(path);
    },
    initPasswordWithOtp() {
      const prepareData = loginService.getPrepareLoginResponse();
      if(prepareData && prepareData.available_login_methods) {
        const foundMethod = prepareData.available_login_methods.find(
            loginMethod => loginMethod.name === this.loginType
        );
        return foundMethod ? foundMethod?.password_with_otp : false;
      }
      return false;
    },

    initLoginName() {
      const loginNameList = LocalStorage.getItem('login_name');
      if (loginNameList) {
        const loginNameByServer = loginNameList[this.backendServerName] || {};
        const loginNameByLoginType = loginNameByServer[this.loginType];
        if (loginNameByLoginType) {
          this.data.loginName = loginNameByLoginType;
        } else if (typeof loginNameByServer === 'object' && loginNameByServer && Object.values(loginNameByServer).length > 0) {
          this.data.loginName = Object.values(loginNameByServer).pop();
        } else if (typeof loginNameList === 'object' && loginNameList && Object.values(loginNameList).length > 0) {
          const loginNameByServer = Object.values(loginNameList).pop();
          this.data.loginName = Object.values(loginNameByServer).pop();
        }
      }

      if (this.data.loginName === undefined) {
        this.data.loginName = '';
      }
    },
    initLoginType() {
      this.loginType = LocalStorage.getItem('login_type') && LocalStorage.getItem('login_type')[this.backendServerName] ?
          LocalStorage.getItem('login_type')[this.backendServerName] :
          'msuite_local';
    },
    async initServerName() {
      this.defaultBackendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetDefaultValue"
      );
      this.backendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
    },
    async checkBackendServerName() {
      const currentBackendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
      const newBackendServerName =
          this.replacedBackendServerName || this.backendServerName;
      if (
          currentBackendServerName &&
          currentBackendServerName === newBackendServerName
      ) {
        return true;
      }

      try {
        await msDataProvider.executeCommand(
            "backendServerNamePing",
            newBackendServerName
        );
      } catch (e) {
        if (
            !(await uiService.executeCommand(
                "confirmShow",
                {
                  message: `${this.$t(
                      "USERNAME_PASSWORD.CANNOT_CONNECT_TO"
                  )} ${newBackendServerName}. ${this.$t(
                      "USERNAME_PASSWORD.DO_YOU_STILL_WANT_TO_CONTINUE"
                  )}?`,
                  title: "Warning",
                  cancel: "Cancel",
                  ok: "Yes",
                  detail: `${e}`,
                },
                true
            ))
        ) {
          return;
        }
      }
      try {
        await msDataProvider.executeCommand(
            "backendServerNameSetCurrentValue",
            newBackendServerName
        );
      } catch (e) {
        return false;
      }

      return true;
    },
  },
  async created() {
    sessionStorage.removeItem("biometricData")
    try {
      await this.initServerName();
      this.initLoginType();
      this.initLoginName();
      this.passwordWithOtp = this.initPasswordWithOtp();
      this.ready = true;
    } catch (e) {
      this.error = e;
    }
  },
});
